module.exports = __webpack_public_path__ + "static/report-cover.d3e81d32.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/report-cover.png
// module id = 216
// module chunks = 35783957827783 267625579013595